import React from "react";
import { WA_LEARN_MORE_HREFS } from "../../Whatsapp/constants/Whatsapp.constants";
import { NOTE_STATUS } from "../modules/StatusNote/constants/StatusNote.constants";

export const whitelabelled_whatsapp_status_constants = {
  PENDING: 1,
  APPROVED: 2, // When step 1 & step 2 is completed
  CONNECTED: 3, // when templates are also approved
  FAILED: 4,
  BLOCKED: 5,
};

export const exly_whatsapp_connect_status_consts = {
  NOT_APPLIED: 1,
  IN_PROGRESS: 2,
  CONNECTED: 3,
  FAILED: 4,
};

export const fb_business_manager_status_consts = {
  // step 2 (business manager profile)
  VERIFIED: 1,
  NOT_VERIFIED: 2,
  FAILED: 3,
  IN_REVIEW: 4,
  PENDING_SUBMISSION: 5,
};

export const whatsapp_whitelabelled_status_keys = {
  success: "success",
  error: "error",
  warning: "warning",
};

export const support_email = "support@exlyapp.com";
export const product_email = "product@myscoot.in";

export const whatsappSteps = {
  connectMeta: 0,
  goToBusinessManager: 1,
  allStepsDone: 2,
};

export const WA_STATUS_NOTE_CONFIGS = {
  ALREADY_REGISTERED: {
    status: NOTE_STATUS.ERROR,
    label: "Failed",
    info: ({ onEmailChange }) => (
      <>
        Your email ID is already registered with AiSensy. You can choose to{" "}
        <span
          className="tw-text-[#0052cc] tw-cursor-pointer hover:tw-underline"
          onClick={onEmailChange}
        >
          change your email ID
        </span>{" "}
        or, contact us at{" "}
        <a href="mailto:support@myscoot.in">support@myscoot.in</a> to be able to
        initiate again.
      </>
    ),
  },

  WABA_IN_REVIEW: {
    status: NOTE_STATUS.WARNING,
    label: "In Progress",
    info: (
      <>
        Your <strong>WhatsApp Business account</strong> has been sent to Meta
        for review.
      </>
    ),
  },

  WABA_CONNECTED: {
    status: NOTE_STATUS.SUCCESS,
    label: "Connected",
    info: (
      <>
        Your <strong>WhatsApp Business account</strong> has been connected
        successfully.
      </>
    ),
  },

  WABA_BLOCKED: {
    status: NOTE_STATUS.ERROR,
    label: "Blocked",
    info: (
      <>
        Your <strong>WhatsApp Business account</strong> is blocked by Meta. You
        won&apos;t be able to start sending messages from your number until this
        issue is resolved. Please contact us at{" "}
        <a href="mailto:support@myscoot.in">support@myscoot.in</a> to fix this
        issue.
      </>
    ),
  },

  WA_DISPLAY_NAME_IN_REVIEW: {
    status: NOTE_STATUS.WARNING,
    label: "In Progress",
    info: (
      <>
        Your <strong>WhatsApp Display name</strong> has been sent to Meta for
        review.
      </>
    ),
  },

  WA_DISPLAY_NAME_APPROVED: {
    status: NOTE_STATUS.SUCCESS,
    label: "Approved",
    info: (
      <>
        Your <strong>WhatsApp Display name</strong> has been approved by Meta.
      </>
    ),
  },

  WA_DISPLAY_NAME_REJECTED: {
    status: NOTE_STATUS.ERROR,
    label: "Rejected",
    info: (
      <>
        Your <strong>WhatsApp Display name</strong> has been rejected by Meta.
        You’ll need to resubmit as per WhatsApp guidelines.{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href={WA_LEARN_MORE_HREFS.DISPLAY_NAME}
        >
          Learn more
        </a>
      </>
    ),
    linkProps: {
      href: WA_LEARN_MORE_HREFS.META_BUSINESS_MANAGER_LOGIN,
      label: "Edit Display Name",
    },
  },

  META_BA_VERIFIED: {
    status: NOTE_STATUS.SUCCESS,
    label: "Verified",
    info: (
      <>
        Your <strong>Meta Business account</strong> has been verified
        successfully by Meta.
      </>
    ),
  },

  META_BA_FAILED: {
    status: NOTE_STATUS.ERROR,
    label: "Failed",
    info: "Log in to your Meta Business Manager to understand why this step has failed.",
  },

  TEMPLATES_REJECTED: {
    status: NOTE_STATUS.ERROR,
    label: "Templates rejected by Meta 😞",
    info: ({ waTemplateRejectCount }) => (
      <>
        {waTemplateRejectCount} templates are rejected by Meta. You would need
        to manually submit them again for approval by logging in to your{" "}
        <strong>Meta Business Manager</strong>.{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href={WA_LEARN_MORE_HREFS.TEMPLATES}
        >
          Learn more
        </a>
      </>
    ),
    linkProps: {
      href: WA_LEARN_MORE_HREFS.META_BUSINESS_MANAGER_LOGIN,
      label: "Go to Meta Business Manager",
    },
  },

  WA_NUMBER_CONNECTED_AND_ACTIVATING: {
    status: NOTE_STATUS.ABOUT_COMPLETED,
    label: (
      <strong>
        You’re almost there!{" "}
        <span className="[-webkit-text-fill-color:initial] tw-bg-none">🥳</span>
      </strong>
    ),
    info: (
      <div className="tw-ml-[25px]">
        Your WhatsApp number has been connected successfully but activating
        might take 1-2 hours as we will be setting up all your previous WhatsApp
        templates (if any) and all WhatsApp automated messages for this number.
        We’ll notify you via email when your WhatsApp number is ready to use!
      </div>
    ),
    withMetaBorder: true,
  },
};

export const WABA_CONNECT_FAILUE_REASON = {
  BUSINESS_EMAIL_ALREADY_EXISTS: 1,
};

export const AI_SENSY_WABA_STATUS = {
  APPROVED: 1,
  PENDING: 2,
  BLOCKED: 3,
  NOT_APPLIED: 4,
};

export const WABA_DISPLAY_NAME_STATUS = {
  IN_PROGRESS: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const WA_TEMPLATES_STATUS = {
  IN_PROGRESS: 1,
  MIGRATED: 2,
  FAILED_AT_EXLY: 3,
  FAILED_AT_FACEBOOK: 4,
};

export const WABA_CONNECT_FAILUE_REASON_NOTE_CONFIGS = {
  [WABA_CONNECT_FAILUE_REASON.BUSINESS_EMAIL_ALREADY_EXISTS]:
    WA_STATUS_NOTE_CONFIGS.ALREADY_REGISTERED,
};

export const WABA_CONNECT_STATUS_NOTE_CONFIGS = {
  [AI_SENSY_WABA_STATUS.PENDING]: WA_STATUS_NOTE_CONFIGS.WABA_IN_REVIEW,
  [AI_SENSY_WABA_STATUS.APPROVED]: WA_STATUS_NOTE_CONFIGS.WABA_CONNECTED,
  [AI_SENSY_WABA_STATUS.BLOCKED]: WA_STATUS_NOTE_CONFIGS.WABA_BLOCKED,
};

export const WABA_DISPLAY_NAME_STATUS_NOTE_CONFIGS = {
  [WABA_DISPLAY_NAME_STATUS.IN_PROGRESS]:
    WA_STATUS_NOTE_CONFIGS.WA_DISPLAY_NAME_IN_REVIEW,
  [WABA_DISPLAY_NAME_STATUS.APPROVED]:
    WA_STATUS_NOTE_CONFIGS.WA_DISPLAY_NAME_APPROVED,
  [WABA_DISPLAY_NAME_STATUS.REJECTED]:
    WA_STATUS_NOTE_CONFIGS.WA_DISPLAY_NAME_REJECTED,
};

export const META_BUSINESS_MANAGER_STATUS_NOTE_CONFIGS = {
  [fb_business_manager_status_consts.VERIFIED]:
    WA_STATUS_NOTE_CONFIGS.META_BA_VERIFIED,
  [fb_business_manager_status_consts.FAILED]:
    WA_STATUS_NOTE_CONFIGS.META_BA_FAILED,
};

export const WA_TEMPLATE_STATUS_NOTE_CONFIGS = {
  [WA_TEMPLATES_STATUS.IN_PROGRESS]:
    WA_STATUS_NOTE_CONFIGS.WA_NUMBER_CONNECTED_AND_ACTIVATING,
  [WA_TEMPLATES_STATUS.FAILED_AT_EXLY]:
    WA_STATUS_NOTE_CONFIGS.WA_NUMBER_CONNECTED_AND_ACTIVATING,
  [WA_TEMPLATES_STATUS.FAILED_AT_FACEBOOK]:
    WA_STATUS_NOTE_CONFIGS.TEMPLATES_REJECTED,
};
